module.exports = __webpack_public_path__ + "01_very_short_black.f4a74dca.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/01_very_short_black.png
// module id = d7LC
// module chunks = 0